export class CreatePurchaseOrderItemMessage {
  inventoryItemId: number
  quantity: number
  useForFulfillmentQuantity: number
  
  constructor(inventoryItemId: number, quantity: number, useForFulfillmentQuantity: number) {
    this.inventoryItemId = inventoryItemId
    this.quantity = quantity
    this.useForFulfillmentQuantity = useForFulfillmentQuantity
  }
}
